import axios from '@/components/api/axios';

async function getPrefectureList() {
  const res = await axios.axiosGet('/api/prefectures/getAll', null);
  return res;
}

export default {
  getPrefectureList
}



// WEBPACK FOOTER //
// ./src/components/api/prefecture.js